import { useEffect } from "react";
import clearAppSession from "../utils/clearAppSession";

const PreLoginPage = () => {
  useEffect(() => {
    // Clear app state only. A blanket sessionStorage.clear() would also wipe
    // the MSAL cache (accounts + refresh token), turning an accidental visit to
    // "/" into an unrecoverable hard logout. Real logout goes through
    // Header -> msalInstance.logoutRedirect(), which clears MSAL properly.
    clearAppSession();
  }, []);

  return (
    <div className="splash-screen-image" data-testid="splash-screen"></div>
  );
};

export default PreLoginPage;
